export const paintIcon = `
<svg viewBox="3 2 24 24">
  <g fill="none" fill-rule="evenodd">
    <g stroke="currentcolor" stroke-linejoin="round">
      <path stroke-width="1.6" d="M15.5 7h1a1 1 0 0 1 1 1v3h-3V8a1 1 0 0 1 1-1Z"/>
      <path stroke-width="2" d="M11 11h10a2 2 0 0 1 2 2v2H9v-2a2 2 0 0 1 2-2ZM22 15l-.888 4.737A4 4 0 0 1 17.18 23H7l.406-.454a8 8 0 0 0 1.903-3.862L10 15"/>
      <path stroke-linecap="round" stroke-width="2" d="m15 23 .64-.715A5.362 5.362 0 0 0 17 19h0"/>
    </g>
  </g>
</svg>
`;
//# sourceMappingURL=icon.js.map